export default "__VITE_ASSET__D9SoGiI1__"